/**
 * Core unit constants for the WARDOGS coordinate system.
 *
 * Confirmed from community map calibration (see the "Coordinate system"
 * section of the root README): the full map render covers 163.84 game units
 * per side, at 100 m per unit, giving a 16.384 km x 16.384 km world =
 * 256 km2, which matches BULKHEAD's own "256km2 map" description.
 */

/** Meters represented by one game coordinate unit. */
export const METERS_PER_UNIT = 100;

/** Full world extent in game units (tile pyramid covers exactly this). */
export const WORLD_UNITS = 163.84;

/** Full world extent in meters. */
export const WORLD_METERS = WORLD_UNITS * METERS_PER_UNIT;

/** NATO mils in a full circle. */
export const MILS_PER_CIRCLE = 6400;

/** Control Zone edge length in meters (2 x 2 km, randomised per match). */
export const CONTROL_ZONE_METERS = 2000;

export function unitsToMeters(units: number): number {
  return units * METERS_PER_UNIT;
}

export function metersToUnits(meters: number): number {
  return meters / METERS_PER_UNIT;
}
